import styled, { css } from 'styled-components';

export const StyledWrapperFields = styled.div`
  position: relative;
  margin-top: 14px;
  margin-bottom: 20px;
`;

export const StyledLabel = styled.label`
  display: flex;
  flex-direction: column;
  font-size: 16px;

  & + & {
    margin-top: 12px;
  }

  &:nth-child(2n + 1):not(:first-child) {
    margin-top: 20px;
  }
`;

export const StyledInput = styled.input`${(props) => (
  css`
    display: inline-block;
    width: 100%;
    height: 36px;
    box-sizing: border-box;
    font-weight: 600;
    padding: 0;
    text-align: center;
    border: 1px solid ${props.borderColor};
    border-radius: 4px;
    margin-top: 6px;
  `
)}`;
